import React, {Component} from 'react';
import {Col, Row} from "reactstrap";
import Iconizer from "./Iconizer";
import {Bar} from "react-chartjs-2";

class ModernCard extends Component {

	constructor(props) {
		super(props);

		this.state = {
			header: false,
			footer: false
		};
	}

	componentDidMount() {
		this.setState({footer: this.props.footer, header: this.props.header})
	}

	render() {

		return (
			<div className="modernCard">
				{this.state.header &&
				<div className="modernCard-header">
					<p>{this.props.title}</p>
				</div>}

				<div className="card-content">
					{this.props.mode === 'quickAccess' &&
					<Row>
						<Col xs='2'>

							<Iconizer name={this.props.name} height={this.props.iconHeight} width={this.props.iconWidth} fill={this.props.fill}/>

						</Col>
						<Col xs='10'>
							<div className='numbers'>
								<p>{this.props.targetName}</p>
								{this.props.info + this.props.unit}
							</div>
						</Col>
					</Row>}

					{this.props.mode === 'barChart' &&
					<Row>
						<Col xs='12'>
							<Bar data={this.props.barData}
								 height={this.props.height}
								 options={{maintainAspectRatio: false}}/>
						</Col>
					</Row>}

					{this.props.mode === 'custom' &&
					this.props.children}
				</div>

				{this.state.footer &&
				<div className='modern-card-footer'>
					<hr/>

					<Row>
						<Col xs='4' />

						<Col xs='8' className='actions-left'>
							<Iconizer name={this.props.actionIcon}
									  height={this.props.actionIconHeight}
									  width={this.props.actionIconWidth}
									  style={{cursor: 'pointer'}}
									  actionMethod={this.props.actionMethod}
									  actionParam={this.props.actionParam}/>
						</Col>
					</Row>
				</div>}
			</div>
		)
	}
}

export default ModernCard;


// WEBPACK FOOTER //
// ./src/components/ModernCard/ModernCard.js